import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DropDownItem } from '@shared-base/generic-clases.base';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownComponent implements OnChanges
{

  @Output() public onItemSelectedChange = new EventEmitter<DropDownItem>();

  @Input() public label: string = "";
  @Input() public parentId: string = "";
  @Input() public isFullWidth: boolean = false;
  @Input() public showError: boolean = false;
  @Input() public coverage: boolean = false;
  @Input() public disabled: boolean = false;

  @Input('selectedValue') public selectedValue: number | string;
  @Input('items') public _items: DropDownItem[];

  public selectedOption: DropDownItem;

  public get items(): DropDownItem[]
  {
    return this._items;
  }

  
  public ngOnChanges(changes: SimpleChanges): void
  {
    if (changes['items'] || changes['selectedValue'])
    {
      this.syncSelectedOption();
    }
  }

  private syncSelectedOption(): void
  {
    if (!this.items || this.items.length === 0)
    {
      this.selectedOption = undefined;
      return;
    }

    const found = this.items.find(x => x.value == this.selectedValue);

    if (found)
    {
      this.selectedOption = found;
    }
    else
    {
      const first = this.items[0];
      this.selectedOption = first;
      this.selectedValue = first.value;
      this.onItemSelectedChange.emit(first);
    }
  }

  public onSelectOption(item: DropDownItem): void
  {
    if (this.disabled)
    {
      return;
    }

    this.selectedValue = item.value;
    this.selectedOption = item;
    this.onItemSelectedChange.emit(item);
  }

  public trackItemBy(index: number, item: DropDownItem): string
  {
    return "dropdownOption_" + this.parentId + "_" + index + "_" + item.value;
  }
}
